/* eslint-disable no-use-before-define,no-mixed-operators */

import React from 'react'
import {default as format_dt} from 'date-fns/format'
import { buy, sell, orderDetail, orderPhone } from './order'

import issuer from './issuer'
import { Detail as IssuerDetail } from './issuer/detail'

export { showBondOrder } from './order'

const formatDt = (a, fmt, zeroHours) => {
    let d = new Date(a)
    if (isNaN(d)) return ''

    if (zeroHours) { d.setHours(0,0,0,0) }

    return format_dt(d, fmt)
}

let empty = (cls="") => {
    return <React.Fragment>
        <span className="screen-reader-only">Empty</span>
        <span aria-hidden="true" className={cls}>--</span>
    </React.Fragment>
}

let slash = (cls="") => {
    return <React.Fragment>
        <span className="screen-reader-only">slash</span>
        <span aria-hidden="true" className={cls}>/</span>
    </React.Fragment>
}

export const format = {
    emptyHtml: `
        <span class="screen-reader-only">Empty</span>
        <span aria-hidden="true">--</span>
    `,
    empty,
    slash,

    ytw: (a, lbl, dv = empty()) => {
        let x = Number.parseFloat(a)
        if (isNaN(x)) return dv
        return `${x.toLocaleString("en-US", {maximumFractionDigits:3})} ${lbl && `<sup> ${lbl}</sup>` || ''}`
    },

    ytw3: (a, lbl) => {
        let x = Number.parseFloat(a)
        if (isNaN(x)) return empty()
        return <React.Fragment>
            {x.toLocaleString("en-US", {minimumFractionDigits:3, maximumFractionDigits:3})}
            {lbl && <sup> {lbl}</sup>}
        </React.Fragment>
    },

    price: (a, dv = empty()) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? dv : x.toLocaleString("en-US", {maximumFractionDigits:3})
    },


    price3: (a) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : x.toLocaleString("en-US", {minimumFractionDigits:3, maximumFractionDigits:3})
    },

    priceDemin: (a) => {
        let x = Number.parseFloat(a)
        if (isNaN(x)) return empty()
        if (x===(-9999) || x===(-1)) return 'N/A'
        return x.toLocaleString("en-US", {minimumFractionDigits:3, maximumFractionDigits:3})
    },

    priceN: (a) => {
        let n = Math.max((((a+'').split('.'))[1] || []).length || 3, 3)
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : x.toLocaleString("en-US", {maximumFractionDigits:n})
    },

    price3N: (a) => {
        let n = Math.max((((a+'').split('.'))[1] || []).length || 3, 3)
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : x.toLocaleString("en-US", {minimumFractionDigits:3, maximumFractionDigits:n})
    },

    price0: (a) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : x.toLocaleString("en-US", {maximumFractionDigits:0})
    },

    cpn: (a, dv = empty(), postfix = '') => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? dv : (x.toLocaleString("en-US", {maximumFractionDigits:3}) + postfix)
    },

    cpn3: (a, dv = empty(), postfix = '') => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? dv : (x.toLocaleString("en-US", {minimumFractionDigits:3, maximumFractionDigits:3}) + postfix)
    },

    cty: (a) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : x.toLocaleString("en-US", {maximumFractionDigits:3})
    },

    dur: (a) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : x.toLocaleString("en-US", {maximumFractionDigits:3})
    },

    pct: (a) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : (x.toLocaleString("en-US", {maximumFractionDigits:3}) + '%')
    },

    qty: (a, opt={}, postfix='') => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : (x.toLocaleString("en-US", opt) + postfix)
    },

    count: (a, dv=empty()) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? dv : x.toLocaleString()
    },

    nvl: (a, t=empty()) => (a===null || a===undefined) ? t : a,

    nullIf: (a, b) => (a === b) ? null : a,

    mdy: (a) => a ? formatDt(a, 'P', true) : empty(),

    time: (a) => formatDt(a, 'hh:mm a'),

    ts: (a) => formatDt(a, 'P hh:mm a'),

    date: (a) => formatDt(a, 'MMMM d, yyyy', true),

    fmtDt: (a, fmt) => formatDt(a, fmt),

    warningText: (a) => String(a || '').replaceAll('|', '<span aria-hidden="true">|</span>'),

    money: (a) => {
        let x = Number.parseFloat(a)
        return isNaN(x) ? empty() : `$${x.toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2})}`
    },

    issuer,
    IssuerDetail,

    buy,
    sell,
    orderDetail,
    orderPhone,

    initCap: (a) => !a ? '' : a.toLowerCase().replace(/(?:^|\s)[a-z]/g, (m) => m.toUpperCase()),

    factor: (a) => {
        let n = Number.parseFloat(a)
        return isNaN(n) ? ''
            : (n % 1) === 0 ? `${n.toLocaleString()}.000`
            : a
    }

}

export const fmt = format


// WEBPACK FOOTER //
// ./src/twd/format/format.js